// eslint-disable-next-line space-before-function-paren
export default function ({ store }) {
  const orderEditId = localStorage.getItem('orderEditId');
  if (store.$auth.isLogged()) {
    setTimeout(() => {
      store.commit('cart/setEditOrderId', orderEditId);
      store.dispatch('cart/getCart');
    }, 1);
  } else {
    localStorage.removeItem('orderEditId');
  }
}
